<template>
  <div v-if="isInitialized">
    <router-view></router-view>
  </div>
</template>

<script>
import Vue from "vue";
import i18n from "./i18n";

export default {
  name: "App",

  data() {
    return {
      isInitialized: false,
    };
  },

  mounted() {
    i18n.locale = this.$store.getters["lang/lang"];
  },

  created() {
    this.setupPrototypes();
    this.initializeApp();
  },

  watch: {
    "$auth.setting": function (newval, preval) {
      if (
        this.isInitialized &&
        (newval == null || newval.length === 0) &&
        this.$auth.init
      ) {
        this.$router.push({ name: "notfound" }).catch(() => {});
      }
    },
    "$store.state.auth.user": {
      handler(newUser) {
        this.loadDeliveryZoneSettings();
      },
      deep: true,
    },
  },

  methods: {
    setupPrototypes() {
      Vue.prototype.base64_encode = (i) => btoa(i);
      Vue.prototype.base64_decode = (i) => atob(i);
    },

    initializeApp() {
      const href = window.location.href;
      let host = window.location.hostname;

      if (host.includes("www.")) {
        host = host.replace("www.", "");
      }

      console.log("host", host);

      if (!host) {
        console.warn("No host found");
        return;
      }

      // Set locale in localStorage
      localStorage.setItem("localelang", this.$store.state.lang.locale);

      // Try to get geolocation with fallback
      this.initializeWithGeolocation(host, href);
    },

    initializeWithGeolocation(host, href) {
      console.log("initializeWithGeolocation")
      if (!navigator.geolocation) {
        console.warn("Geolocation is not supported");
        // this.initializeWithoutGeolocation(host, href);
        return;
      }

      // Set a timeout for geolocation
      const geoOptions = {
        timeout: 10000, // 10 seconds
        enableHighAccuracy: false,
        maximumAge: 300000, // 5 minutes
      };

      navigator.geolocation.getCurrentPosition(
        (pos) => {
          console.log("Geolocation obtained successfully");
          const latitude =  localStorage.getItem("latitude") || pos.coords.latitude;
          const longitude =  localStorage.getItem("longitude") || pos.coords.longitude;

          this.initializeWithLocation(
            host,
            href,
            latitude,
            longitude
          );
        },
        (error) => {
          console.warn("Geolocation failed:", error.message);
          // this.initializeWithoutGeolocation(host, href);
          // this.$router.push({ name: 'home' });
        },
        geoOptions
      );
    },

    async initializeWithLocation(host, href, latitude, longitude) {
      try {
        // Store location
        localStorage.setItem("latitude", latitude);
        localStorage.setItem("longitude", longitude);

        // Set vendor settings
        const processedHost = host === "localhost" ? "sta.ug" : host;

        await this.$auth.setVendorSettings({
          order_web: processedHost,
          is_langauge: this.$store.state.lang.locale,
          latitude: latitude,
          longitude: longitude,
        });

        // Initialize user
        await this.initUser(href);

        // Load delivery zones
        await this.loadDeliveryZoneSettings();

        this.isInitialized = true;
        console.log("App initialized successfully with location");
      } catch(error) {
        console.log(error)
        console.log("Error initializing with location:");
        // this.$router.push({ name: 'home' });
        this.isInitialized = true;
      }
    },

    // async initializeWithoutGeolocation(host, href) {
    //   try {
    //     // Set vendor settings without location
    //     await this.$auth.setVendorSettings({
    //       order_web: host,
    //       is_langauge: this.$store.state.lang.locale,
    //       latitude: null,
    //       longitude: null,
    //     });

    //     // Initialize user
    //     await this.initUser(href);

    //     this.isInitialized = true;
    //     console.log("App initialized successfully without location");
    //   } catch (error) {
    //     // console.error("Error initializing without location:", error);
    //     this.$router.push({ name: 'home' });
    //   }
    // },

    async initUser(href) {
      return new Promise((resolve) => {
        this.$auth.setUser((type) => {
          if (type) {
            const currentRoute = href.substring(href.lastIndexOf("/") + 1);
            if (currentRoute === "sign-in") {
              this.$router.push({ name: type }).catch(() => {});
            }
          }
          resolve();
        });
      });
    },

    async loadDeliveryZoneSettings() {
      try {
        const data = {
          vendor_id: this.$auth.getVendorId(),
          lat: localStorage.getItem("latitude") || null,
          lan: localStorage.getItem("longitude") || null,
        };

        await this.$store.dispatch("setting/getDeliveryZoneSetting", data);
        console.log("Delivery zone settings loaded successfully");
      } catch (error) {
        console.error("Error loading delivery zone settings:", error);
      }
    },
  },
};
</script>